import styled, { createGlobalStyle } from 'styled-components';

export const AuctionCalendarStyles = createGlobalStyle`
  .ag-theme-alpine-dark .ag-row.selected-auction-row {
    background-color: rgba(252, 216, 57, 0.3) !important;
    border-left: 4px solid #fcd839 !important;
    
    /* Add a top border for better visibility when scrolled to top */
    border-top: 2px solid #fcd839 !important;
    /* Add slight shadow to make it stand out more */
    box-shadow: 0 0 8px rgba(252, 216, 57, 0.2) !important;
    
    &:hover {
      background-color: rgba(252, 216, 57, 0.4) !important;
    }

    /* Style all cells in the selected row */
    .ag-cell {
      font-weight: 600;
    }
  }
  
  /* Super slow animation for a clearly visible scroll-to-top experience */
  .ag-theme-alpine-dark .ag-center-cols-viewport,
  .ag-theme-alpine-dark .ag-body-viewport {
    scroll-behavior: smooth;
    transition: all 5000ms cubic-bezier(0.12, 0.46, 0.45, 0.94) !important; /* Extremely slow transition with custom easing */
  }
  
  /* Highlight animation for the selected row to draw attention */
  @keyframes highlightSelectedRow {
    0% { background-color: rgba(252, 216, 57, 0.3); }
    20% { background-color: rgba(252, 216, 57, 0.7); }
    40% { background-color: rgba(252, 216, 57, 0.3); }
    60% { background-color: rgba(252, 216, 57, 0.7); }
    80% { background-color: rgba(252, 216, 57, 0.3); }
    100% { background-color: rgba(252, 216, 57, 0.3); }
  }
  
  .ag-theme-alpine-dark .ag-row.selected-auction-row.scrolling-active {
    animation: highlightSelectedRow 8s ease-in-out;
  }
`;

export const AuctionCalendarContainer = styled.div``;